import React, { useState, useEffect } from 'react';

const LoadingFallback = ({ 
  message = 'Yükleniyor...', 
  timeout = 15000,
  onTimeout,
  showTimeoutWarning = true,
  allowRetry = true 
}) => {
  const [timeoutReached, setTimeoutReached] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
      if (onTimeout) {
        onTimeout();
      }
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout, onTimeout, retryCount]);

  const handleRetry = () => {
    setTimeoutReached(false);
    setRetryCount(prev => prev + 1);
    if (onTimeout) {
      onTimeout(true); // retry flag
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  if (timeoutReached && showTimeoutWarning) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
        <div className="max-w-md w-full text-center">
          <div className="text-yellow-500 text-6xl mb-6">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            Yükleme Süresi Aşıldı
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Sayfa beklenen sürede yüklenemedi. Bu durum ağ bağlantısı veya sunucu yoğunluğundan kaynaklanabilir.
          </p>
          
          <div className="space-y-3">
            {allowRetry && (
              <button
                onClick={handleRetry}
                className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
              >
                Tekrar Dene {retryCount > 0 && `(${retryCount})`}
              </button>
            )}
            
            <button
              onClick={handleReload}
              className="w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200"
            >
              Sayfayı Yenile
            </button>
            
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">
              <p>Sorun devam ederse:</p>
              <ul className="mt-2 space-y-1">
                <li>• İnternet bağlantınızı kontrol edin</li>
                <li>• Tarayıcınızın önbelleğini temizleyin</li>
                <li>• Birkaç dakika sonra tekrar deneyin</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          <div className="absolute inset-0 rounded-full border-2 border-gray-200 dark:border-gray-700"></div>
        </div>
        
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">
            {message}
          </p>
          
          <div className="mt-2 w-48 bg-gray-200 dark:bg-gray-700 rounded-full h-1">
            <div 
              className="bg-blue-500 h-1 rounded-full transition-all duration-300"
              style={{
                width: `${Math.min((Date.now() % timeout) / timeout * 100, 100)}%`
              }}
            ></div>
          </div>
          
          <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
            Maksimum {timeout / 1000} saniye bekleniyor...
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingFallback; 